// 運用解析（/analysis/*）を誰に見せるか。
//
// **公開範囲は3段階で広げる。いまは第2段階。**
//
//   1. super_admin だけ
//   2. ログインユーザー    ← いまここ（2026-09-11）
//   3. 一般公開
//
// 下の ANALYSIS_ACCESS を書き換えるだけで、ルートガード・メニュー・
// SightingModal の導線がまとめて切り替わる。
//
// **バックエンド側（backend/routes/api.php の運用解析 group）も
// 一緒に変えること。** ここだけ変えても API が 403 を返す。
//
// 判断材料は duty:evaluate の実測。第2段階へ進めた時点で、アイランド・
// 平日11日・台日854 の便的中率 97.4%・網羅率 90.0%（目標90%）。
// 詳細は OPERATION_ANALYSIS_PLAN.md

export const ANALYSIS_ACCESS = "authenticated"; // 'super_admin' | 'authenticated' | 'public'

export function canUseAnalysis(currentUser) {
  return allowed(ANALYSIS_ACCESS, currentUser);
}

// 解析そのものを見る3画面（要確認・健康診断・観測の穴）を誰に見せるか。
//
// **ここは ANALYSIS_ACCESS とは別に持つ。** 乗番の中身を見る画面と、
// 乗番が正しいかどうかを見る画面は役割が違う。後者は運用の内輪の数字で、
// 利用者向けの画面に混ぜるものではない。要確認とダイヤ改正には人が裁定を
// 書き込む口（PUT）もある。
//
// **ANALYSIS_ACCESS を広げるときに、つられてこちらを広げないこと。**
// 対応する API は backend/routes/api.php の別 group に分けてある。
export const ANALYSIS_INTERNALS_ACCESS = "super_admin"; // 'super_admin' | 'authenticated' | 'public'

export function canUseAnalysisInternals(currentUser) {
  return allowed(ANALYSIS_INTERNALS_ACCESS, currentUser);
}

// 路線図 View（/analysis/line-map）を誰に見せるか(260923追加)。
//
// **ANALYSIS_INTERNALS_ACCESS から切り出した。**2026-09-15 から 09-23 までは
// 走行位置がどれくらい埋まるか分からず、解析の様子と同じ super_admin 側に
// 置いていた。ログインユーザーへ開けるときに内輪の 3 画面を巻き込まないよう、
// 別に持つ。
//
// 広げる／狭めるときは **backend/routes/api.php の line-maps の group も
// 一緒に変える。** 片方だけでは出ない／403。
export const LINE_MAP_ACCESS = "authenticated"; // 'super_admin' | 'authenticated' | 'public'

export function canUseLineMap(currentUser) {
  return allowed(LINE_MAP_ACCESS, currentUser);
}

// お気に入り車両の「今日の運用」（/favorites の上のカード）を誰に見せるか。
//
// **設計としては ANALYSIS_ACCESS とは独立している。** 返すのは自分が
// お気に入りに登録した車だけなので、任意の車号を追える窓にはならず、
// 一般公開の判断（網羅率90%）を待たずにログインユーザーへ出せる。
//
// **それでも当面は super_admin だけに出す**（2026-09-05 の判断）。
// 本番でもこの設定のまま動いている。止めているのではなく、狭く出している。
//
// 広げるときは下を 'authenticated' にして、**backend/routes/api.php の
// /user/favorites/today から role.super_admin を外す。** 両方要る。
export const FAVORITES_TODAY_ACCESS = "super_admin"; // 'super_admin' | 'authenticated' | 'public'

export function canUseFavoritesToday(currentUser) {
  return allowed(FAVORITES_TODAY_ACCESS, currentUser);
}

function allowed(level, currentUser) {
  switch (level) {
    case "public":
      return true;
    case "authenticated":
      return Boolean(currentUser);
    case "super_admin":
    default:
      return currentUser?.user_role_id === 1;
  }
}
